var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('div',{staticClass:"content"},[_c('cpt-header'),_c('cpt-credit'),_c('cpt-introduce'),_c('cpt-process'),_c('cpt-intelligent'),_c('cpt-advantages'),_c('cpt-bottom')],1),_c('cpt-change-lang')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }